import { Button, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { deleteComboSet } from "../../api/ApiComboSet";

const DeleteView = ({ idItem, onClose }: DeleteProduct) => {
  const handleDeleteProduct = async () => {
    await deleteComboSet({ data: idItem, onClose });
    modals.closeAll();
    // onSearch();
  };

  return (
    <div>
      <Text size="24px">bạn có chắc chắn muốn xóa các Combo set này ?</Text>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="#3598dc"
          onClick={handleDeleteProduct}
          leftSection={<IconCheck size={18} />}
        >
          Xóa
        </Button>
        <Button
          type="button"
          color="#3598dc"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Hủy
        </Button>
      </Group>
    </div>
  );
};

type DeleteProduct = {
  idItem: (number | string)[];
  onClose: any;
};

export default DeleteView;
